import dayjs from 'dayjs'
import utc from 'dayjs/plugin/utc.js'
dayjs.extend(utc);
import getItemStyles from '../../../utils/item-styles.js';
import fixAmAndPm from '../../../../../utils/fixAmAndPm.js';
import daylightSavingsCheck from '../../../../../utils/daylightSavingsCheck.js';

/**
 * Returns an assignment item that can be displayed in the 7 to 9 day posted schedule.
 * It will be visible in the day the parent tour's start time. The color/design is based upon one of four options that it is
 * assigned based upon the order it falls in the assignment array.
 * @param {*} rId
 * @param {*} dayType
 * @param {*} assignment
 * @param {*} assignmentCase
 */
const generateAssignments = (resource, dayType, assignment, assignmentCase, startTimeTour, timeOffset, startDate, scheduleType, scheduleFormat, scheduleLength) => {
  const { rId } = resource;
  const { startTime, endTime, jeId, jobId, requestNumber, status, comment, description, myAssignmentComment, isApproved } = assignment;
  
  let rdtId;
  let displayStartTime;
  let displayEndTime;

  if (startTimeTour) {
    rdtId = dayType.rdtId;
    displayStartTime = dayjs(dayjs.unix(startTimeTour).utc().format("YYYY-MM-DD HH:mm:ss")).startOf('day')
    displayEndTime =  dayjs(dayjs.unix(startTimeTour).utc().format("YYYY-MM-DD HH:mm:ss")).endOf('day')
  } else { // stand-by assignment jeStatus === 10?
    rdtId = dayType.assignment.jeId;
    displayStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss")).startOf('day');
    displayEndTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss")).endOf('day');
  }

  let hasComment = false;
  if (comment || description || myAssignmentComment) {
    hasComment = true;
  }

  let itemStyle;
  if (assignmentCase === 3) {
    if (assignment && assignment.reconciled === '1') {
      itemStyle = getItemStyles(4);
    } else if (assignment.status === '20') {
      itemStyle = getItemStyles(5);
    } else {
      itemStyle = getItemStyles(3);
    }
  } else {
    itemStyle = getItemStyles(assignmentCase);
  }


  const assignmentStartTime = dayjs(dayjs.unix(startTime).utc().format("YYYY-MM-DD HH:mm:ss"));
  const assignmentEndTime = dayjs(dayjs.unix(endTime).utc().format("YYYY-MM-DD HH:mm:ss"));

  let DSTNeutralAssignmentStartTime =assignmentStartTime;
  let DSTNeutralAssignmentEndTime = assignmentEndTime;

  // blank assignments are where startTime is equal to endTime on 7&9 day schedules
  let blankAssignment;
  if (DSTNeutralAssignmentStartTime.format() === DSTNeutralAssignmentEndTime.format()) {
    blankAssignment = true;
  }

  const assignmentAdjusted = {
    id: jeId,
    jobId,
    requestNumber,
    itemType: 'assignment',
    group: rId === undefined ? resource : rId,
    start_time: displayStartTime,
    end_time: displayEndTime,
    title: !blankAssignment ? fixAmAndPm(DSTNeutralAssignmentStartTime.format('h:mma')) + '-'
      + fixAmAndPm(DSTNeutralAssignmentEndTime.format('h:mma')): '',
    modalStartTime:DSTNeutralAssignmentStartTime.format('MM-DD-YYYY h:mma'),
    modalEndTime: DSTNeutralAssignmentEndTime.format('MM-DD-YYYY h:mma'),
    rdtId,
    status,
    backgroundColor: !assignment.isApproved ? itemStyle.backgroundColor : "gray",
    color: itemStyle.color,
    borderStyle: itemStyle.borderStyle,
    borderColor: hasComment ? "red" : itemStyle.borderColor,
    resourceClass: resource.class,
    isApproved
  };

  return assignmentAdjusted;
}

export default generateAssignments;
